import React from "react";

export const AfsolSectionCard = ({ title, children, className = "", testId }) => {
  return (
    <section className={`overflow-hidden rounded-lg border border-slate-300 bg-white ${className}`} data-testid={testId}>
      <div className="bg-[#4d90c7] px-3 py-2 text-sm font-semibold text-white">{title}</div>
      <div className="p-3">{children}</div>
    </section>
  );
};

export default AfsolSectionCard;